import { useParams } from 'react-router';
import {
  SendingPlatform,
  CUSTOM_EMAIL,
  CUSTOM_PUSH,
  ITERABLE,
  SENDGRID,
  MAILGUN,
  SPARKPOST,
  DYN,
  TELNYX,
  TWILIO,
  ITERABLE_SMS,
  WHATS_APP,
} from 'modules/sendingPlatforms/constants';
import { ModalContextProvider } from 'utils/contexts/modal';
import { SendingPlatformsQueryContextProvider, TakeoverContextProvider } from '../../contexts';
import { CustomPushPage } from './Push/CustomPushPage';
import { CustomEmailPage } from './Email/CustomEmailPage';
import { WhatsAppPage } from './WhatsApp/WhatsAppPage';
import { EmailPage } from './Email/EmailPage';
import { SESPage } from './Email/SESPage';
import { SmsPage } from './Sms/SmsPage';

const PageBySendingPlatform = (sendingPlatform: SendingPlatform) => {
  switch (sendingPlatform) {
    case ITERABLE:
      return SESPage;
    case SENDGRID:
    case MAILGUN:
    case SPARKPOST:
    case DYN:
      return EmailPage;
    case CUSTOM_EMAIL:
      return CustomEmailPage;
    case TELNYX:
    case TWILIO:
    case ITERABLE_SMS:
      return SmsPage;
    case CUSTOM_PUSH:
      return CustomPushPage;
    case WHATS_APP:
      return WhatsAppPage;
    default:
      return null;
  }
};

export const SendingPlatformsDetailsPage = () => {
  const { sendingPlatform } = useParams<{ sendingPlatform: SendingPlatform }>();

  const Page = PageBySendingPlatform(sendingPlatform);

  return (
    <ModalContextProvider>
      <TakeoverContextProvider>
        <SendingPlatformsQueryContextProvider>
          {Page && <Page sendingPlatform={sendingPlatform} />}
        </SendingPlatformsQueryContextProvider>
      </TakeoverContextProvider>
    </ModalContextProvider>
  );
};
